// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Pie } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// ChartJS.register(ArcElement, Tooltip, Legend);

// const ExchangeApiUrl = "https://api.exchangerate-api.com/v4/latest/USD";

// const Overview = () => {
//   const BaseUrl = process.env.REACT_APP_API;

//   const [TotalCurrentEquity, setTotalCurrentEquity] = useState(0);
//   const [exchangeRates, setExchangeRates] = useState({});
//   const [bankAccounts, setBankAccounts] = useState([]);
//   const [data, setData] = useState({
//     binanceAUM: 0,
//     banksAUM: 0,
//     equityAUM: 0,
//     otherShareClass: 0,
//     totalAUM: 0,
//   });

//   // Fetch exchange rates
//   const fetchExchangeRates = async () => {
//     try {
//       const response = await axios.get(ExchangeApiUrl);
//       setExchangeRates(response.data.rates);
//     } catch (error) {
//       console.error("Error fetching exchange rates:", error);
//     }
//   };

//   // Convert amount to USD
//   const convertToUSD = (amount, currency) => {
//     if (currency === "USD") return amount;
//     const rate = exchangeRates[currency] || 1;
//     return amount / rate;
//   };

//   // Fetch bank accounts
//   const fetchBankAccounts = async () => {
//     try {
//       const response = await axios.get(`${BaseUrl}/accounts`);
//       setBankAccounts(response.data);
//     } catch (error) {
//       console.error("Error fetching accounts:", error);
//     }
//   };

//   // Fetch Binance data
//   const fetchBinanceData = async () => {
//     try {
//       const [main, sub1, sub2, sub3] = await Promise.all([
//         axios.get(`${BaseUrl}/api/binance/balance/main`),
//         axios.get(`${BaseUrl}/api/binance/balance/sub1`),
//         axios.get(`${BaseUrl}/api/binance/balance/sub2`),
//         axios.get(`${BaseUrl}/api/binance/balance/sub3`),
//       ]);

//       const binanceTotal =
//         parseFloat(main.data.totalBalanceUSDT) +
//         parseFloat(sub1.data.totalBalanceUSDT) +
//         parseFloat(sub2.data.totalBalanceUSDT) +
//         parseFloat(sub3.data.totalBalanceUSDT);

//       const totalBalanceUSD = bankAccounts.reduce(
//         (acc, account) => acc + convertToUSD(account.available_balance, account.currency),
//         0
//       );

//       const equityAUM = convertToUSD(TotalCurrentEquity, "INR");
//       const totalAUM = binanceTotal + totalBalanceUSD + equityAUM + data.otherShareClass;

//       setData({
//         binanceAUM: binanceTotal,
//         banksAUM: totalBalanceUSD,
//         equityAUM: equityAUM,
//         otherShareClass: data.otherShareClass,
//         totalAUM: totalAUM,
//       });
//     } catch (error) {
//       console.error("Error fetching Binance data:", error);
//     }
//   };

//   // Fetch Total Current Equity
//   const fetchTotalCurrentEquity = async () => {
//     try {
//       const response = await axios.get(`${BaseUrl}/equities`);
//       setTotalCurrentEquity(response.data.totalCurrent);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchExchangeRates();
//     fetchBankAccounts();
//     fetchTotalCurrentEquity();
//   }, []);

//   useEffect(() => {
//     if (TotalCurrentEquity > 0 && bankAccounts.length > 0 && Object.keys(exchangeRates).length > 0) {
//       fetchBinanceData();
//     }
//   }, [TotalCurrentEquity, bankAccounts, exchangeRates]);

//   const calculatePercentage = (value, total) => (total === 0 ? 0 : ((value / total) * 100).toFixed(2));

//   const chartData = {
//     labels: [
//       `Binance AUM (${calculatePercentage(data.binanceAUM, data.totalAUM)}%)`,
//       `Banks AUM (${calculatePercentage(data.banksAUM, data.totalAUM)}%)`,
//       `Equity AUM (${calculatePercentage(data.equityAUM, data.totalAUM)}%)`,
//       `Other share class AUM (${calculatePercentage(data.otherShareClass, data.totalAUM)}%)`,
//     ],
//     datasets: [
//       {
//         data: [data.binanceAUM, data.banksAUM, data.equityAUM, data.otherShareClass],
//         backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
//         hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
//       },
//     ],
//   };
    

//     return (
//       <div className="container mt-4">
//         <div className="row">
//           {/* Total AUM */}
//           <div className="col-12">
//                 <div className="card basic-data-table">
//                   <div className="card-header text-white text-center">
//                     <h4 className="mb-0">Total AUM (Blueaster Capital)</h4>
//                   </div>
//                   <div className="card-body text-center">
//                     <h3>${data.totalAUM.toFixed(2)}</h3>
//                   </div>
//                 </div>
//               </div>

//           {/* Right Side - AUM Data */}
//           <div className="col-md-6">
//             <div className="row">
//               {/* Binance AUM */}
//               <div className="col-12 mb-3">
//                 <div className="card basic-data-table">
//                   <div className="card-header text-white text-center">
//                     <h6 className="mb-0">Binance AUM</h6>
//                   </div>
//                   <div className="card-body text-center">
//                     <h6>${data.binanceAUM.toFixed(2)}</h6>
//                   </div>
//                 </div>
//               </div>

//               {/* Banks AUM */}
//               <div className="col-12 mb-3">
//                 <div className="card basic-data-table">
//                   <div className="card-header text-white text-center">
//                     <h6 className="mb-0">Banks AUM</h6>
//                   </div>
//                   <div className="card-body text-center">
//                     <h6>${data.banksAUM.toFixed(2)}</h6>
//                   </div>
//                 </div>
//               </div>

//               {/* Equity AUM */}
//               <div className="col-12 mb-3">
//                 <div className="card basic-data-table">
//                   <div className="card-header text-white text-center">
//                     <h6 className="mb-0">Equity AUM</h6>
//                   </div>
//                   <div className="card-body text-center">
//                     <h6>${data.equityAUM.toFixed(2)}</h6>
//                     {/* <h6>${totalEquityInUSD.toFixed(2)}</h6> */}
//                   </div>
//                 </div>
//               </div>
              
//               <div className="col-12 mb-3">
//                 <div className="card basic-data-table">
//                   <div className="card-header text-white text-center">
//                     <h6 className="mb-0">Other Share-class</h6>
//                   </div>
//                   <div className="card-body text-center">
//                     <h6>${data.otherShareClass.toFixed(2)}</h6>
//                   </div>
//                 </div>
//               </div>
             

              
//             </div>
            
//           </div>  
//                 {/* Left Side - Pie Chart */}
//                 <div className="col-md-6 d-flex justify-content-center align-items-center">
//                 <div className="card p-3 w-100 d-flex flex-column align-items-center">
//   <div className="card-header text-center">
//     <h5>Overview of AUM</h5>
//   </div>
//   <div className="d-flex justify-content-center align-items-center" style={{ width: "100%", maxWidth: "350px", height: "350px" }}>
//     <Pie data={chartData} />
//   </div>
//                 </div>

//           </div>
//         </div>
//       </div>
//     );
// };

// export default Overview;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const ExchangeApiUrl = "https://api.exchangerate-api.com/v4/latest/USD";

const Overview = () => {
  const BaseUrl = process.env.REACT_APP_API;

  const [TotalCurrentEquity, setTotalCurrentEquity] = useState(0);
  const [exchangeRates, setExchangeRates] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);
  const [data, setData] = useState({
    binanceAUM: 0,
    banksAUM: 0,
    equityAUM: 0,
    otherShareClass: 0,
    totalAUM: 0,
  });

  const fetchExchangeRates = async () => {
    try {
      const response = await axios.get(ExchangeApiUrl);
      setExchangeRates(response.data.rates);
    } catch (error) {
      console.error("Error fetching exchange rates:", error);
    }
  };

  const convertToUSD = (amount, currency) => {
    if (currency === "USD") return amount;
    const rate = exchangeRates[currency] || 1;
    return amount / rate;
  };

  const fetchBankAccounts = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/accounts`);
      setBankAccounts(response.data);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  const fetchBinanceData = async () => {
    try {
      const [main, sub1, sub2, sub3] = await Promise.all([
        axios.get(`${BaseUrl}/api/binance/balance/main`),
        axios.get(`${BaseUrl}/api/binance/balance/sub1`),
        axios.get(`${BaseUrl}/api/binance/balance/sub2`),
        axios.get(`${BaseUrl}/api/binance/balance/sub3`),
      ]);

      const binanceTotal =
        parseFloat(main.data.totalBalanceUSDT) +
        parseFloat(sub1.data.totalBalanceUSDT) +
        parseFloat(sub2.data.totalBalanceUSDT);
      
      const sub3Balance = parseFloat(sub3.data.totalBalanceUSDT);
      
      const totalBalanceUSD = bankAccounts.reduce(
        (acc, account) => acc + convertToUSD(account.available_balance, account.currency),
        0
      );

      const equityAUM = convertToUSD(TotalCurrentEquity, "INR");
      const otherShareClass = data.otherShareClass + sub3Balance;
      const totalAUM = binanceTotal + totalBalanceUSD + equityAUM + otherShareClass;

      setData({
        binanceAUM: binanceTotal,
        banksAUM: totalBalanceUSD,
        equityAUM: equityAUM,
        otherShareClass: otherShareClass,
        totalAUM: totalAUM,
      });
    } catch (error) {
      console.error("Error fetching Binance data:", error);
    }
  };

  const fetchTotalCurrentEquity = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/equities`);
      setTotalCurrentEquity(response.data.totalCurrent);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchExchangeRates();
    fetchBankAccounts();
    fetchTotalCurrentEquity();
  }, []);

  useEffect(() => {
    if (TotalCurrentEquity > 0 && bankAccounts.length > 0 && Object.keys(exchangeRates).length > 0) {
      fetchBinanceData();
    }
  }, [TotalCurrentEquity, bankAccounts, exchangeRates]);

  const calculatePercentage = (value, total) => (total === 0 ? 0 : ((value / total) * 100).toFixed(2));

  const chartData = {
    labels: [
      `Binance AUM (${calculatePercentage(data.binanceAUM, data.totalAUM)}%)`,
      `Banks AUM (${calculatePercentage(data.banksAUM, data.totalAUM)}%)`,
      `Equity AUM (${calculatePercentage(data.equityAUM, data.totalAUM)}%)`,
      `Other share class AUM (${calculatePercentage(data.otherShareClass, data.totalAUM)}%)`,
    ],
    datasets: [
      {
        data: [data.binanceAUM, data.banksAUM, data.equityAUM, data.otherShareClass],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"],
      },
    ],
  };

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="card basic-data-table">
            <div className="card-header text-white text-center">
              <h4 className="mb-0">Total AUM (Blueaster Capital)</h4>
            </div>
            <div className="card-body text-center">
              <h3>${data.totalAUM.toFixed(2)}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row">
            <div className="col-12 mb-3">
              <div className="card basic-data-table">
                <div className="card-header text-white text-center">
                  <h6 className="mb-0">Binance AUM</h6>
                </div>
                <div className="card-body text-center">
                  <h6>${data.binanceAUM.toFixed(2)}</h6>
                </div>
              </div>
            </div>

               <div className="col-12 mb-3">
                 <div className="card basic-data-table">
                   <div className="card-header text-white text-center">
                     <h6 className="mb-0">Banks AUM</h6>
                   </div>
                   <div className="card-body text-center">
                     <h6>${data.banksAUM.toFixed(2)}</h6>
                   </div>
                 </div>
               </div>

            
               <div className="col-12 mb-3">
                 <div className="card basic-data-table">
                   <div className="card-header text-white text-center">
                     <h6 className="mb-0">Equity AUM</h6>
                   </div>
                   <div className="card-body text-center">
                     <h6>${data.equityAUM.toFixed(2)}</h6>
                    
                   </div>
                 </div>
               </div>

            <div className="col-12 mb-3">
              <div className="card basic-data-table">
                <div className="card-header text-white text-center">
                  <h6 className="mb-0">Other Share-class</h6>
                </div>
                <div className="card-body text-center">
                  <h6>${data.otherShareClass.toFixed(2)}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 d-flex justify-content-center align-items-center">
          <div className="card p-3 w-100 d-flex flex-column align-items-center">
            <div className="card-header text-center">
              <h5>Overview of AUM</h5>
            </div>
            <div className="d-flex justify-content-center align-items-center" style={{ width: "100%", maxWidth: "350px", height: "350px" }}>
              <Pie data={chartData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
